import { useEnabledField, useSoundField } from '../../../form'
import { FormKeys } from '../../../form/constants'
import NotificationToggleItem from '../NotificationToggleItem'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface OrderAcceptedToggleItemProps {
    disabled: boolean
}

const OrderAcceptedToggleItem: FC<OrderAcceptedToggleItemProps> = ({ disabled }) => {
    const { t } = useTranslation()

    const [enabled, setEnabled] = useEnabledField(FormKeys.OrderAccepted)
    const [sound, setSound] = useSoundField(FormKeys.OrderAccepted)

    return (
        <NotificationToggleItem
            label={t('settings.notifications.field.orderAccepted.label')}
            description={t('settings.notifications.field.orderAccepted.description')}
            checked={enabled}
            onChange={setEnabled}
            disabled={disabled}
            sound={sound}
            onSoundChange={setSound}
        />
    )
}

export default OrderAcceptedToggleItem
